import React, { useState } from "react";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
  Button,
} from "reactstrap";
import image from "../assets/img/custom/GRAPHIC_SEASONAL_SYSTEM.png";
import image2 from "../assets/img/custom/addvideoImge.png";
import SeasonalImage from "../assets/img/custom/seasnol img.png";
import Notation from "../assets/img/custom/NOTATION_-_POST_ON_FHP_IN_GOOD_SPOT.png";
import SeasonCard from "../assets/img/custom/SEASON_CARD_IN_PLASTIC_PROTECTOR_.png";

const items = [
  {
    src: image2,
    altText: "Slide 1",
    key: 1,
  },
  {
    src: image,
    altText: "Slide 2",
    key: 2,
  },
  {
    src: SeasonCard,
    altText: "Slide 3",
    key: 3,
  },
  {
    src: SeasonalImage,
    altText: "Slide 4",
    key: 4,
  },
  {
    src: Notation,
    altText: "Slide 5",
    key: 5,
  },
];

function ImageSlider(args) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        <img src={item.src} alt={item.altText} className="img-fluid mx-auto" />
        <CarouselCaption
          captionText={item.caption}
          captionHeader={item.caption}
        />
      </CarouselItem>
    );
  });

  return (
    <div>
      <Carousel
        activeIndex={activeIndex}
        next={next}
        previous={previous}
        {...args}
      >
        <CarouselIndicators
          items={items}
          activeIndex={activeIndex}
          onClickHandler={goToIndex}
        />
        {slides}
        <CarouselControl
          direction="prev"
          directionText="Previous"
          onClickHandler={previous}
        />
        <CarouselControl
          direction="next"
          directionText="Next"
          onClickHandler={next}
        />
      </Carousel>
      <div className="text-center mt-3">
        <Button color="primary" size="sm" onClick={previous}>
          &#9664;
        </Button>{" "}
        <Button color="primary" size="sm" onClick={next}>
          &#9654;
        </Button>
      </div>
    </div>
  );
}

export default ImageSlider;
